export const b2cPolicies = {
  names: {
    signIn: "B2C_1_partner-susi",
    forgotPassword: "B2C_1_partner_resetpwd",
    editProfile: "B2C_1_partner_editprofile",
  },
  authorities: {
    signIn: {
      authority:
        "https://inextlabspartners.b2clogin.com/inextlabspartners.onmicrosoft.com/b2c_1_partner-susi",
    },
    forgotPassword: {
      authority:
        "https://inextlabspartners.b2clogin.com/inextlabspartners.onmicrosoft.com/B2C_1_partner_resetpwd",
    },
    editProfile: {
      authority:
        "https://inextlabspartners.b2clogin.com/inextlabspartners.onmicrosoft.com/B2C_1_partner_editprofile",
    },
  },
  authorityDomain: "inextlabspartners.b2clogin.com",
};

export const msalConfig = {
  auth: {
    clientId: "6a19aec0-98a4-4e61-92ed-aefa006773a9", // Live demo.inextlabs.ai B2C Client ID
    authority: b2cPolicies.authorities.signIn.authority, // Live Azure B2C Policy Authority
    knownAuthorities: [b2cPolicies.authorityDomain], // Trusted B2C Domain
    redirectUri:
      typeof window !== "undefined" && window.location.hostname === "localhost"
        ? "http://localhost:3000/"
        : window.location.origin,
    postLogoutRedirectUri:
      typeof window !== "undefined" && window.location.hostname === "localhost"
        ? "http://localhost:3000/"
        : window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {
        // All MSAL logs hidden
      },
    },
    allowRedirectInIframe: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access"],
};
